import { useState, useEffect } from 'react'

import { Drawer } from 'antd'
import { useSelector } from 'react-redux'

import { selectUser } from '../../reducers/UserReducer'
import { getContactPersonSpecialitiesBySchool } from '../../utils/api/users'
import SmartTable, { SmartTableDataTypes } from './SmartTable'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const ContactPersonSpecialitiesSchoolWidget = props => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [contactPersonSchoolSpecialities, setContactPersonSchoolSpecialities] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (props.user !== null && user !== null) {
      getContactPersonSpecialitiesBySchool(props.user, props.school, user)
        .then(data => {
          data.map(schoolSpeciality => {
            schoolSpeciality.name = schoolSpeciality.specialityYear.specialityAbbreviation + ' (' + schoolSpeciality.specialityYear.studyYearName + ')'
          })

          setContactPersonSchoolSpecialities(data)
          setLoading(false)
        })
    }
  }, [props.user, user])

  const COLUMNS = [
    {
      type: SmartTableDataTypes.STRING,
      name: t('Specialities'),
      key: 'name'
    }
  ]

  return (
    <Drawer
      title={props.user !== null ? t('Specialities managed by') + ' ' + props.user.email : '?'}
      width='640px'
      onClose={props.onClose}
      visible={props.user !== null}
    >
      <SmartTable
        loading={loading}
        columns={COLUMNS}
        data={contactPersonSchoolSpecialities}
        noDataText={t('Without speciality')}
      />
    </Drawer>
  )
}

export default ContactPersonSpecialitiesSchoolWidget
